export class Annulationdto {
    date : boolean ;
    debut : string ;
    fin : string ;
    type : string ;
}
